import { ReactNode, useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../app/hooks"
import { LoadingContainer } from "../../../app/LoadingContainer"
import { impossible } from "../../../app/Utils"
import { selectDocument } from "../documentSlice"
import { loadDocumentAllTests } from "./documentTestsApi"

export interface DocumentTestLoaderProps {
    asyncLoading: boolean
    children: ReactNode
}

export const DocumentTestLoader = (props: DocumentTestLoaderProps) => {
    const { asyncLoading, children } = props

    const dispatch = useAppDispatch()

    const { header } = useAppSelector(selectDocument)?.doc ?? impossible()
    const loaded = useAppSelector(state => selectDocument(state).doc?.tests.loaded ?? false)

    useEffect(() => {
        if (!loaded) {
            dispatch(loadDocumentAllTests({
                documentId: parseInt(header.id),
            }))
        }
    }, [loaded])

    const content = asyncLoading || loaded ? <>{children}</> : <LoadingContainer />

    return <>{content}</>
}
